import React, {useEffect, useMemo,  useState} from "react";
import "./PerformanceDashboard.css";
import Menubar from "../Menubar";
import {store} from "../../App";
import * as Yup from "yup";
import KpiService from "../../Services/KpiService";
import {AiFillFileExcel} from "react-icons/ai";
import {useFormik} from "formik";
import AlertModal from "../Alert/AlertModal";
import useAlert from "../Alert/useAlert";
import {Modal, Table, Button, Container} from "react-bootstrap";
import {exportToExcel, generatePdf} from "../utils/commonFunctions";
import {MdOutlinePictureAsPdf} from "react-icons/md";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const PerformanceMonitoringReport = () => {
    const {showAlert, alertData, showAlertMessage, closeAlert} = useAlert();
    const [showTable, setShowTable] = useState(false);
    const [reportData, setReportData] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [popupTitle, setPopupTitle] = useState("");
    const [popupData, setPopupData] = useState([]);
    const [searchPopup, setSearchPopup] = useState("");
    const [indicatorPopupData, setIndicatorPopupData] = useState([]);
    const [indicatorPopupTitle, setIndicatorPopupTitle] = useState("");
    const [searchIndicator, setSearchIndicator] = useState("");
    const [indicatorSelected, setIndicatorSelected] = useState(false);
    const [monthOptions, setMonthOptions] = useState([]);
    const [searchSummary, setSearchSummary] = useState("");
    const [sortColumn, setSortColumn] = useState(null);
    const [sortDirection, setSortDirection] = useState("asc");
    const [selectedZone, setSelectedZone] = useState(null);
    const [selectedDistrictId, setSelectedDistrictId] = useState(null);
    const [table1DrillLevel, setTable1DrillLevel] = useState("dist");
    const [showTable4, setShowTable4] = useState(false);
    const [table4Data, setTable4Data] = useState([]);
    const [table4SortColumn, setTable4SortColumn] = useState(null);
    const [table4SortDirection, setTable4SortDirection] = useState("asc");
    const [table4Search, setTable4Search] = useState("");

    let username = localStorage.getItem("username");
    let districtid = localStorage.getItem("districtid");

    const generatePdff = (tableId, fileName, columnsCount, title = "") => {
        const doc = new jsPDF("p", "pt", "a4");
        let startY = 20;
        if (title) {
            doc.setFont("helvetica", "bold");
            doc.setFontSize(16);
            doc.text(title, doc.internal.pageSize.getWidth() / 2, 25, {
                align: "center",
            });
            startY = 40;
        }
        autoTable(doc, {
            html: tableId,
            startY,
            theme: "grid",
            styles: {fontSize: 9, halign: "center", valign: "middle"},
            headStyles: {fontStyle: "bold"},
            bodyStyles: {textColor: 0},
            margin: {top: startY, left: 15, right: 15},

            didParseCell: function (data) {
                if (tableId !== "#summary-table") return;

                if (data.section === "body") {
                    if (data.column.index === 1) {
                        data.cell.styles.halign = "left";
                    }

                    const value = Array.isArray(data.cell.text)
                        ? data.cell.text.join(" ").trim()
                        : String(data.cell.text || "").trim();

                    if (value.includes("Achiever")) {
                        data.cell.styles.fillColor = [237, 247, 237];
                        data.cell.styles.textColor = [46, 125, 50];
                        data.cell.styles.fontStyle = "bold";
                    } else if (value.includes("Front Runner")) {
                        data.cell.styles.fillColor = [255, 248, 230];
                        data.cell.styles.textColor = [178, 106, 0];
                        data.cell.styles.fontStyle = "bold";
                    } else if (value.includes("Performer")) {
                        data.cell.styles.fillColor = [238, 247, 253];
                        data.cell.styles.textColor = [21, 101, 192];
                        data.cell.styles.fontStyle = "bold";
                    } else if (value.includes("Aspirant")) {
                        data.cell.styles.fillColor = [253, 238, 238];
                        data.cell.styles.textColor = [198, 40, 40];
                        data.cell.styles.fontStyle = "bold";
                    } else if (value === "-") {
                        data.cell.styles.textColor = [120, 120, 120];
                        data.cell.styles.halign = "center";
                    }
                }
            },
            didDrawPage: function (data) {
                doc.setFontSize(10);
                doc.text(
                    `Page ${doc.internal.getNumberOfPages()}`,
                    doc.internal.pageSize.getWidth() - 60,
                    doc.internal.pageSize.getHeight() - 10
                );
            },
        });
        doc.save(`${fileName}.pdf`);
    };

    const generatePerformancePdf = (tableId, fileName, title = "") => {
        const doc = new jsPDF("p", "pt", "a4");

        let startY = 20;

        if (title) {
            doc.setFont("helvetica", "bold");
            doc.setFontSize(16);
            doc.text(title, doc.internal.pageSize.getWidth() / 2, 25, {align: "center"});
            startY = 40;
        }

        autoTable(doc, {
            html: tableId,
            startY,
            theme: "grid",

            styles: {
                fontSize: 9,
                halign: "center",
                valign: "middle",
                lineColor: [0, 0, 0],
                lineWidth: 0.2,
            },

            didParseCell: function (data) {
                // Main heading
                if (data.section === "head" && data.row.index === 0) {
                    data.cell.styles.fillColor = [78, 131, 92];
                    data.cell.styles.textColor = [255, 255, 255];
                    data.cell.styles.fontStyle = "bold";
                }

                // Column colors
                if (data.section === "head" && data.row.index === 1) {
                    switch (data.column.index) {
                        case 1:
                            data.cell.styles.fillColor = [108, 192, 74]; // A+
                            break;

                        case 2:
                            data.cell.styles.fillColor = [247, 198, 0]; // A
                            break;

                        case 3:
                            data.cell.styles.fillColor = [78, 205, 196]; // B
                            break;

                        case 4:
                            data.cell.styles.fillColor = [255, 90, 90]; // C
                            break;

                        default:
                            data.cell.styles.fillColor = [78, 131, 92];
                    }

                    data.cell.styles.textColor = [255, 255, 255];
                    data.cell.styles.fontStyle = "bold";
                }
            },
        });

        doc.save(`${fileName}.pdf`);
    };

    const handleGradeClickMandal = (row, grade) => {
        if (formik.values.type === "dist") {
            const popup = reportData
            .filter((item) => item.cs_indicator_type === row.section && item.grade === grade)
            .map((item) => ({
                district: item.district_name,
                total: item.ind_count,
            }));

            setPopupTitle(`${row.section} - ${grade}`);
            setPopupData(popup);
            setShowPopup(true);
        } else if (formik.values.type === "mandal") {
            const popup = reportData
            .filter((item) => item.cs_indicator_type === row.section && item.grade === grade)
            .map((item) => ({
                district_name: item.district_name,
                mandal_name: item.mandal_name,
                total: item.ind_count,
            }));

            setPopupTitle(`${row.section} - ${grade}`);
            setPopupData(popup);
            setShowPopup(true);
        } else if (formik.values.type === "const") {
            const popup = reportData
            .filter((item) => item.cs_indicator_type === row.section && item.grade === grade)
            .map((item) => ({
                district_name: item.district_name,
                acname: item.acname,
                accode: item.accode,
                total: item.ind_count,
            }));

            setPopupTitle(`${row.section} - ${grade}`);
            setPopupData(popup);
            setShowPopup(true);
        }
    };

    const handleIndicatorClick = (item) => {
        if (formik.values.type === "dist") {
            const district = reportData.find(
                (r) =>
                    r.district_name === item.district &&
                    r.cs_indicator_type === popupTitle.split(" - ")[0] &&
                    r.grade === popupTitle.split(" - ")[1]
            );
            const indicators = district?.ind_with_score
                ? district.ind_with_score.split("$").map((x) => {
                      const [indicatorName, score] = x.split("@@");
                      return {
                          indicator_name: indicatorName.trim(),
                          indicator_score: parseFloat(score.trim()),
                      };
                  })
                : [];

            setIndicatorPopupData(indicators);
            setIndicatorSelected(true);
            setIndicatorPopupTitle(`${item.district} \u00A0 (${popupTitle})`);
        } else if (formik.values.type === "mandal") {
            const mandal = reportData.find(
                (r) =>
                    r.district_name === item.district_name &&
                    r.mandal_name === item.mandal_name &&
                    r.cs_indicator_type === popupTitle.split(" - ")[0] &&
                    r.grade === popupTitle.split(" - ")[1]
            );
            const indicators = mandal?.ind_with_score
                ? mandal.ind_with_score.split("$").map((x) => {
                      const [indicatorName, score] = x.split("@@");
                      return {
                          indicator_name: indicatorName?.trim() || "",
                          indicator_score: parseFloat(score?.trim() || 0),
                      };
                  })
                : [];

            setIndicatorPopupData(indicators);
            setIndicatorSelected(true);
            setIndicatorPopupTitle(`${item.district_name} - ${item.mandal_name}  \u00A0\u00A0 (${popupTitle})`);
        } else if (formik.values.type === "const") {
            const constituency = reportData.find(
                (r) =>
                    String(r.accode) === String(item.accode) &&
                    r.cs_indicator_type === popupTitle.split(" - ")[0] &&
                    r.grade === popupTitle.split(" - ")[1]
            );

            const indicators = constituency?.ind_with_score
                ? constituency.ind_with_score.split("$").map((x) => {
                      const [indicatorName, score] = x.split("@@");

                      return {
                          indicator_name: indicatorName?.trim() || "",
                          indicator_score: parseFloat(score?.trim() || 0),
                      };
                  })
                : [];

            setIndicatorPopupData(indicators);
            setIndicatorSelected(true);
            setIndicatorPopupTitle(`${item.district_name} - ${item.acname} (${popupTitle})`);
        }
    };

    const validationSchema = Yup.object({});
    const formik = useFormik({
        initialValues: {category: "", year: "", month: "", type: ""},
        validationSchema: validationSchema,
        onSubmit: async (values) => {},
    });

    const scoreForMonth =
        formik.values.category === "month"
            ? formik.values.month || "0"
            : formik.values.category === "provisional" || formik.values.category === "annual"
            ? "3"
            : "0";
    const scoreCatId =
        formik.values.category === "month"
            ? "Monthly"
            : formik.values.category === "provisional"
            ? "Provisionally"
            : formik.values.category === "annual"
            ? "Annually"
            : "Monthly";
    const categoryOptions = [
        {value: "month", label: "Month"},
        {value: "provisional", label: "Provisional"},
        {value: "annual", label: "Annual"},
    ];

    const fetchMonthsMandal = async () => {
        try {
            const params = {userId: username, year: formik.values.year, type: "CRITERISDASHBOARD"};
            const response = await KpiService.monthNameFromMonthCode(params);
            if (response?.data?.SCODE === "01" && response.data.dataList) {
                const months = response.data.dataList.map((month) => ({
                    value: month.month_code,
                    label: month.month_name,
                }));
                setMonthOptions(months);
                const maxMonth = months.length
                    ? [...months].sort((a, b) => Number(b.value) - Number(a.value))[0]?.value?.toString() || ""
                    : "";

                formik.setFieldValue("month", maxMonth);
                // const firstMonth = months?.[0]?.value?.toString() || ""; formik.setFieldValue("month", firstMonth);
            } else {
                setMonthOptions([]);
            }
        } catch (error) {
            console.error("Error fetching months:", error);
            setMonthOptions([]);
        }
    };

    useEffect(() => {
        if (formik.values.year) {
            fetchMonthsMandal();
        } else {
            setMonthOptions([]);
            formik.setFieldValue("month", "");
        }
    }, [formik.values.year]);

    useEffect(() => {
        if (monthOptions.length > 0) {
            const firstMonth = monthOptions[0].value;
            if (!formik.values.month) {
                formik.setFieldValue("month", firstMonth);
            }
            if (
                formik.values.type &&
                formik.values.category &&
                formik.values.year &&
                (formik.values.category !== "month" || firstMonth)
            ) {
                return;
            } else {
                showAlertMessage("Please select all required fields", "warning");
            }
        }
    }, [monthOptions]);

    const loadInitialReport = async () => {
        try {
            store.dispatch({type: "SHOW_SPINNER"});
            const params = {
                userId: username,
                year: formik.values.year,
                scoreCatId,
                scoreForMonth,
                type: formik.values.type,
            };
            // if(drilldown){ params.type="mandal"; params.districtId= String(distid)}
            if (formik.values.type === "mandal") {
                params.districtId = "0";
            }

            const res = await KpiService.economicPerformanceMonitoringReport(params);

            if (res?.data?.SCODE === "01") {
                setSortColumn(null);
                setSortDirection("asc");
                setReportData(res.data.dataList || []);
                setShowTable(true);
            } else if (res?.data?.SCODE === "02") {
                setReportData([]);
                setShowTable(false);
                showAlertMessage(res.data.SDESC, "warning");
            } else {
                setReportData([]);
                setShowTable(false);
                showAlertMessage(res?.data?.SDESC || "No Data Found", "warning");
            }
        } catch (error) {
            console.error(error);
            setReportData([]);
            setShowTable(false);
            showAlertMessage("Something went wrong", "error");
        } finally {
            store.dispatch({type: "HIDE_SPINNER"});
        }
    };

    useEffect(() => {
        if (!formik.values.type || !formik.values.category || !formik.values.year) {
            return;
        }

        if (formik.values.category === "month") {
            if (!formik.values.month) {
                return;
            }
        }

        loadInitialReport();
        // if ( table1DrillLevel === "mandal" && selectedDistrictId !== null ) { loadInitialReport(true, selectedDistrictId);
        // } else { setSelectedDistrictId(null); setTable1DrillLevel("dist"); loadInitialReport(false, null); }
    }, [formik.values.category, formik.values.year, formik.values.month]);

    const groupedReport = useMemo(() => {
        if (!Array.isArray(reportData)) return [];

        const result = {
            Economic: {
                section: "Economic",
                "A+": new Set(),
                A: new Set(),
                B: new Set(),
                C: new Set(),
            },
            Social: {
                section: "Social",
                "A+": new Set(),
                A: new Set(),
                B: new Set(),
                C: new Set(),
            },
            Governance: {
                section: "Governance",
                "A+": new Set(),
                A: new Set(),
                B: new Set(),
                C: new Set(),
            },
        };

        reportData.forEach((item) => {
            const type = item.cs_indicator_type;
            const grade = item.grade;

            const key =
                formik.values.type === "dist"
                    ? item.district_id
                    : formik.values.type === "mandal"
                    ? item.mandal_id
                    : item.accode;

            if (result[type] && result[type][grade]) {
                result[type][grade].add(key);
            }
        });

        return Object.values(result).map((r) => ({
            section: r.section,
            "A+": r["A+"].size,
            A: r["A"].size,
            B: r["B"].size,
            C: r["C"].size,
            total: new Set([...r["A+"], ...r["A"], ...r["B"], ...r["C"]]).size,
        }));
    }, [reportData, formik.values.type]);

    const districtSummary = useMemo(() => {
        if (!Array.isArray(reportData)) return [];

        const map = {};

        const getGradeDetails = (grade) => {
            switch (grade) {
                case "A+":
                    return {
                        text: "Achiever (A+)",
                        bg: "#edf7ed",
                        color: "#2e7d32",
                    };

                case "A":
                    return {
                        text: "Front Runner (A)",
                        bg: "#fff8e6",
                        color: "#b26a00",
                    };

                case "B":
                    return {
                        text: "Performer (B)",
                        bg: "#eef7fd",
                        color: "#1565c0",
                    };

                case "C":
                    return {
                        text: "Aspirant (C)",
                        bg: "#fdeeee",
                        color: "#c62828",
                    };

                default:
                    return {
                        text: "-",
                        bg: "#fff",
                        color: "#666",
                    };
            }
        };

        // Grade based on average score
        const getAverageGrade = (score) => {
            if (score === null || score === undefined || isNaN(score)) {
                return "-";
            }

            if (score >= 90) return "A+";
            if (score >= 75) return "A";
            if (score >= 50) return "B";
            return "C";
        };

        reportData.forEach((item) => {
            if (item.row_type === "ZONE_TOTAL") {
                return;
            }
            if (
                table1DrillLevel === "mandal" &&
                selectedDistrictId !== null &&
                Number(item.district_id) !== Number(selectedDistrictId)
            ) {
                return;
            }
            const currentTableLevel = table1DrillLevel !== "dist" ? table1DrillLevel : formik.values.type;
            // const key = formik.values.type === "dist" ? item.district_id : formik.values.type === "mandal" ? item.mandal_id : item.accode;

            const key =
                formik.values.type === "dist"
                    ? item.district_id
                    : formik.values.type === "mandal"
                    ? item.mandal_id
                    : item.accode;

            if (!map[key]) {
                map[key] = {
                    district:
                        formik.values.type === "mandal" || formik.values.type === "const" ? item.district_name : "",

                    zone: item.zone_name,
                    zoneId: item.zone_id,

                    name:
                        formik.values.type === "dist"
                            ? item.district_name
                            : formik.values.type === "mandal"
                            ? item.mandal_name
                            : item.acname,

                    districtId: Number(item.district_id),
                    mandalId: Number(item.mandal_id),
                    constId: Number(item.accode),

                    Economic: "-",
                    Social: "-",
                    Governance: "-",

                    // Store section scores
                    EconomicScore: null,
                    SocialScore: null,
                    GovernanceScore: null,

                    totalGroupingScore: 0,
                    totalIndicatorCount: 0,

                    averageScore: null,
                    averageGrade: "-",
                };
            }

            // map[key][item.cs_indicator_type] = { ...getGradeDetails(item.grade), score: item.indicator_score };
            map[key][item.cs_indicator_type] = {...getGradeDetails(item.grade), score: item.indicator_score};

            const groupingScore = Number(item.tot_sum_grouping_score);
            const indicatorCount = Number(item.ind_count);

            if (!isNaN(groupingScore)) {
                map[key].totalGroupingScore += groupingScore;
            }

            if (!isNaN(indicatorCount)) {
                map[key].totalIndicatorCount += indicatorCount;
            }
        });

        Object.values(map).forEach((row) => {
            const totalScore = Number(row.totalGroupingScore);
            const totalIndicators = Number(row.totalIndicatorCount);

            if (totalIndicators > 0) {
                const average = totalScore / totalIndicators;

                row.averageScore = Math.round(average);
                row.averageGrade = getAverageGrade(average);
            } else {
                row.averageScore = null;
                row.averageGrade = "-";
            }
        });

        return Object.values(map).sort((a, b) => {
            if (formik.values.type === "dist") {
                return a.districtId - b.districtId;
            }

            if (formik.values.type === "mandal" || selectedDistrictId !== null) {
                if (a.districtId !== b.districtId) {
                    return a.districtId - b.districtId;
                }

                return a.mandalId - b.mandalId;
            }

            if (formik.values.type === "const") {
                if (a.districtId !== b.districtId) {
                    return a.districtId - b.districtId;
                }

                return a.constId - b.constId;
            }
        });
    }, [reportData, formik.values.type]);

    const getGradeDetails = (grade) => {
        switch (grade) {
            case "A+":
                return {
                    text: "Achiever (A+)",
                    bg: "#edf7ed",
                    color: "#2e7d32",
                };

            case "A":
                return {
                    text: "Front Runner (A)",
                    bg: "#fff8e6",
                    color: "#b26a00",
                };

            case "B":
                return {
                    text: "Performer (B)",
                    bg: "#eef7fd",
                    color: "#1565c0",
                };

            case "C":
                return {
                    text: "Aspirant (C)",
                    bg: "#fdeeee",
                    color: "#c62828",
                };

            default:
                return {
                    text: "-",
                    bg: "#fff",
                    color: "#666",
                };
        }
    };

    const zoneSummary = reportData.filter((item) => item.row_type === "ZONE_TOTAL");

    const filteredSummary = districtSummary.filter((item) => {
        if (selectedZone && String(item.zoneId).toUpperCase() !== String(selectedZone).toUpperCase()) {
            return false;
        }

        if (!item.name || item.name.trim() === "") {
            return false;
        }

        const search = searchSummary.toLowerCase().trim();

        if (!search) return true;

        return (
            // District / Mandal / Constituency
            item.name?.toLowerCase().includes(search) ||
            item.district?.toLowerCase().includes(search) ||
            // Section grades / categorization
            item.Economic?.text?.toLowerCase().includes(search) ||
            item.Social?.text?.toLowerCase().includes(search) ||
            item.Governance?.text?.toLowerCase().includes(search) ||
            // Grade values
            item.Economic?.text
            ?.match(/\((A\+|A|B|C)\)/)?.[1]
            ?.toLowerCase()
            .includes(search) ||
            item.Social?.text
            ?.match(/\((A\+|A|B|C)\)/)?.[1]
            ?.toLowerCase()
            .includes(search) ||
            item.Governance?.text
            ?.match(/\((A\+|A|B|C)\)/)?.[1]
            ?.toLowerCase()
            .includes(search) ||
            // Overall Score
            String(item.averageScore ?? "").includes(search) ||
            // Overall Grade
            item.averageGrade?.toLowerCase().includes(search)
        );
    });

    // const filteredPopupData =
    //     formik.values.type === "dist"
    //         ? popupData.filter((item) => item.district?.toLowerCase().includes(searchPopup.toLowerCase()))
    //         : formik.values.type === "mandal"
    //         ? popupData.filter(
    //               (item) =>
    //                   item.district_name?.toLowerCase().includes(searchPopup.toLowerCase()) ||
    //                   item.mandal_name?.toLowerCase().includes(searchPopup.toLowerCase())
    //           )
    //         : popupData.filter(
    //               (item) =>
    //                   item.district_name?.toLowerCase().includes(searchPopup.toLowerCase()) ||
    //                   item.acname?.toLowerCase().includes(searchPopup.toLowerCase())
    //           );

    const filteredPopupData = useMemo(() => {
    const search = searchPopup.trim().toLowerCase();

    if (!search) return popupData;

    return popupData.filter((item) => {
        return Object.values(item).some((value) =>
            String(value ?? "")
                .toLowerCase()
                .includes(search)
        );
    });
}, [popupData, searchPopup]);

    const reportName =
        formik.values.type === "dist"
            ? "DistrictPerformanceMonitoringReport"
            : formik.values.type === "mandal"
            ? "MandalPerformanceMonitoringReport"
            : "ConstituencyPerformanceMonitoringReport";

    const getRingColor = (score) => {
        if (score >= 90) return "#6cc04a";
        if (score >= 75) return "#f7c600";
        if (score >= 50) return "#2fb4ff";
        return "#ff5a5a";
    };

    const renderStatusRing = (score, maxScore = 100, size = 40, strokeWidth = 6) => {
        const parsedScore = Number(score) || 0;

        const radius = (size - strokeWidth) / 2;
        const circumference = 2 * Math.PI * radius;
        const progress = (Math.min(parsedScore, maxScore) / maxScore) * circumference;
        const ringColor = getRingColor(parsedScore);

        return (
            <svg width={size} height={size}>
                <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="#e6e6e6" strokeWidth={strokeWidth} />
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill="none"
                    stroke={ringColor}
                    strokeWidth={strokeWidth}
                    strokeDasharray={circumference}
                    strokeDashoffset={circumference - progress}
                    strokeLinecap="round"
                    transform={`rotate(-90 ${size / 2} ${size / 2})`}
                />

                <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fontSize="10" fontWeight="bold">
                    {parsedScore}
                </text>
            </svg>
        );
    };

    const selectedMonth = monthOptions.find((m) => String(m.value) === String(formik.values.month))?.label || "";

    const reportTitle =
        `Section-wise ${
            formik.values.type === "dist" ? "District" : formik.values.type === "mandal" ? "Mandal" : "Constituency"
        } Performance Monitoring Report` +
        ` - ${scoreCatId}` +
        `${formik.values.category === "month" ? ` (${selectedMonth})` : ""}` +
        ` - ${formik.values.year}`;

    // const filteredIndicatorData = indicatorPopupData.filter((item) =>
    //     item.indicator_name?.toLowerCase().includes(searchIndicator.toLowerCase())
    // );

    const filteredIndicatorData = useMemo(() => {
    const search = searchIndicator.trim().toLowerCase();

    if (!search) return indicatorPopupData;

    return indicatorPopupData.filter((item) => {
        return Object.values(item).some((value) =>
            String(value ?? "")
                .toLowerCase()
                .includes(search)
        );
    });
}, [indicatorPopupData, searchIndicator]);

    const handleClosePopup = () => {
        setShowPopup(false);
        setIndicatorSelected(false);
        setIndicatorPopupData([]);
        setIndicatorPopupTitle("");
        setSearchIndicator("");
        setPopupData([]);
        setPopupTitle("");
        setSearchPopup("");
    };

    const fileSuffix =
        `${formik.values.year}_${scoreCatId}` + (formik.values.category === "month" ? `_${selectedMonth}` : "");

    //Sorting
    const handleSort = (column) => {
        if (sortColumn !== column) {
            // First click → ascending
            setSortColumn(column);
            setSortDirection("asc");
        } else if (sortDirection === "asc") {
            // Second click → descending
            setSortDirection("desc");
        } else {
            // Third click → normal/original order
            setSortColumn(null);
            setSortDirection("asc");
        }
    };

    const sortedSummary = [...filteredSummary].sort((a, b) => {
        if (!sortColumn) return 0;

        let valueA;
        let valueB;

        if (sortColumn === "Economic") {
            valueA = Number(a.Economic?.score ?? -1);
            valueB = Number(b.Economic?.score ?? -1);
        } else if (sortColumn === "Social") {
            valueA = Number(a.Social?.score ?? -1);
            valueB = Number(b.Social?.score ?? -1);
        } else if (sortColumn === "Governance") {
            valueA = Number(a.Governance?.score ?? -1);
            valueB = Number(b.Governance?.score ?? -1);
        } else if (sortColumn === "Score") {
            valueA = Number(a.averageScore ?? -1);
            valueB = Number(b.averageScore ?? -1);
        } else if (sortColumn === "Grade") {
            const gradeOrder = {
                "A+": 4,
                A: 3,
                B: 2,
                C: 1,
                "-": 0,
            };

            valueA = gradeOrder[a.averageGrade] ?? 0;
            valueB = gradeOrder[b.averageGrade] ?? 0;
        }

        if (typeof valueA === "string") {
            return sortDirection === "asc" ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
        }

        return sortDirection === "asc" ? valueA - valueB : valueB - valueA;
    });

    // const handleDistrictClick = async (item) => {
    //     const districtId = item.districtId;

    //     setSelectedDistrictId(districtId);
    //     setTable1DrillLevel("mandal");

    //     loadInitialReport(true, item.district_id);
    // };

    const loadTable4Data = async (districtId) => {
        try {
            store.dispatch({type: "SHOW_SPINNER"});

            const params = {
                userId: username,
                year: formik.values.year,
                scoreCatId,
                scoreForMonth,

                type: "mandal",
                districtId: String(districtId),
            };

            console.log("TABLE 4 PARAMS:", params);

            const res = await KpiService.economicPerformanceMonitoringReport(params);

            if (res?.data?.SCODE === "01") {
                setTable4Data(res.data.dataList || []);
                setShowTable4(true);
            } else {
                setTable4Data([]);
                setShowTable4(true);
            }
        } catch (error) {
            console.error(error);
            setTable4Data([]);
        } finally {
            store.dispatch({type: "HIDE_SPINNER"});
        }
    };

    const table4Summary = useMemo(() => {
        if (!Array.isArray(table4Data)) return [];

        const map = {};

        table4Data.forEach((item) => {
            const key = item.mandal_id;

            if (!key) return;

            if (!map[key]) {
                map[key] = {
                    district_name: item.district_name || "-",
                    district_id: item.district_id,
                    mandal_name: item.mandal_name || "-",
                    mandal_id: item.mandal_id,
                    zone: item.zone_name,

                    Economic: null,
                    Social: null,
                    Governance: null,

                    totalGroupingScore: 0,
                    totalIndicatorCount: 0,

                    overallScore: null,
                    overallGrade: "-",
                };
            }

            // Section-wise score and grade
            if (item.cs_indicator_type === "Economic") {
                map[key].Economic = {
                    score: Number(item.indicator_score),
                    grade: item.grade || "-",
                };
            }

            if (item.cs_indicator_type === "Social") {
                map[key].Social = {
                    score: Number(item.indicator_score),
                    grade: item.grade || "-",
                };
            }

            if (item.cs_indicator_type === "Governance") {
                map[key].Governance = {
                    score: Number(item.indicator_score),
                    grade: item.grade || "-",
                };
            }

            // Overall calculation
            const groupingScore = Number(item.tot_sum_grouping_score);
            const indicatorCount = Number(item.ind_count);

            if (!isNaN(groupingScore)) {
                map[key].totalGroupingScore += groupingScore;
            }

            if (!isNaN(indicatorCount)) {
                map[key].totalIndicatorCount += indicatorCount;
            }
        });

        // Calculate overall score and grade
        Object.values(map).forEach((row) => {
            if (row.totalIndicatorCount > 0) {
                const score = row.totalGroupingScore / row.totalIndicatorCount;

                row.overallScore = Math.round(score);

                if (score >= 90) {
                    row.overallGrade = "A+";
                } else if (score >= 75) {
                    row.overallGrade = "A";
                } else if (score >= 50) {
                    row.overallGrade = "B";
                } else {
                    row.overallGrade = "C";
                }
            }
        });

        return Object.values(map);
    }, [table4Data]);

    const handleDistrictClick = (row) => {
        const districtId = row.districtId;

        if (districtId === null || districtId === undefined) {
            console.error("District ID missing:", row);
            return;
        }

        setSelectedDistrictId(districtId);

        // Only Table 4 will be displayed
        setShowTable4(true);

        // Call API for Mandal data
        loadTable4Data(districtId);
    };

    // ================= TABLE 4 SORTING =================

    const handleTable4Sort = (column) => {
        if (table4SortColumn !== column) {
            // First click → ascending
            setTable4SortColumn(column);
            setTable4SortDirection("asc");
        } else if (table4SortDirection === "asc") {
            // Second click → descending
            setTable4SortDirection("desc");
        } else {
            // Third click → original order
            setTable4SortColumn(null);
            setTable4SortDirection("asc");
        }
    };

    const filteredTable4Summary = table4Summary.filter((row) => {
        const searchText = table4Search.trim().toLowerCase();

        if (!searchText) return true;

        const getGradeText = (grade) => {
            switch (grade) {
                case "A+":
                    return "Achiever A+";
                case "A":
                    return "Front Runner A";
                case "B":
                    return "Performer B";
                case "C":
                    return "Aspirant C";
                default:
                    return "-";
            }
        };

        const searchableText = [
            row.sno,
            row.zone_name,
            row.zone,
            row.district_name,
            row.mandal_name,

            // Economic
            row.Economic?.score,
            row.Economic?.grade,
            getGradeText(row.Economic?.grade),

            // Social
            row.Social?.score,
            row.Social?.grade,
            getGradeText(row.Social?.grade),

            // Governance
            row.Governance?.score,
            row.Governance?.grade,
            getGradeText(row.Governance?.grade),

            // Overall
            row.overallScore,
            row.overallGrade,
            getGradeText(row.overallGrade),
        ]
        .filter((value) => value !== null && value !== undefined)
        .join(" ")
        .toLowerCase();

        return searchableText.includes(searchText);
    });

    const sortedTable4Summary = [...filteredTable4Summary].sort((a, b) => {
        if (!table4SortColumn) return 0;

        let valueA;
        let valueB;

        if (table4SortColumn === "Economic") {
            valueA = Number(a.Economic?.score ?? -1);
            valueB = Number(b.Economic?.score ?? -1);
        } else if (table4SortColumn === "Social") {
            valueA = Number(a.Social?.score ?? -1);
            valueB = Number(b.Social?.score ?? -1);
        } else if (table4SortColumn === "Governance") {
            valueA = Number(a.Governance?.score ?? -1);
            valueB = Number(b.Governance?.score ?? -1);
        } else if (table4SortColumn === "Score") {
            valueA = Number(a.overallScore ?? -1);
            valueB = Number(b.overallScore ?? -1);
        } else if (table4SortColumn === "Grade") {
            const gradeOrder = {
                "A+": 4,
                A: 3,
                B: 2,
                C: 1,
                "-": 0,
            };

            valueA = gradeOrder[a.overallGrade] ?? 0;
            valueB = gradeOrder[b.overallGrade] ?? 0;
        }

        if (typeof valueA === "string") {
            return table4SortDirection === "asc" ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
        }

        return table4SortDirection === "asc" ? valueA - valueB : valueB - valueA;
    });

    return (
        <>
            <div style={{width: "100%", minHeight: "100vh", backgroundColor: "#f4f6f9"}}>
                <Menubar />
                <Container fluid style={{width: "96%", background: "#f4f6f9"}}>
                    {" "}
                    <div className="sa-title">
                        {" "}
                        <h2>
                            {" "}
                            District / Mandal Performance <span>Monitoring Report </span>{" "}
                        </h2>{" "}
                    </div>{" "}
                </Container>

                <div
                    style={{
                        background: "#f4f6f9",
                        padding: "25px 0 60px 0",
                        minHeight: "70vh",
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <div style={{width: "100%", maxWidth: "90%", padding: 12}}>
                        <div style={{display: "grid", alignItems: "center", marginBottom: 12}}>
                            <div className="col-12 col-lg-12 col-md-12 col-xl-12 col-xxl-12 col-sm-12 col-xs-12">
                                <div className="row g-2 align-items-end sdg-dash flex-nowrap">
                                    <>
                                        <div className="col-12 col-md-2 d-flex flex-column gap-1">
                                            <label className="mb-0">
                                                {" "}
                                                Level <span className="text-danger">*</span>{" "}
                                            </label>
                                            <select
                                                className="form-select"
                                                name="type"
                                                value={formik.values.type}
                                                onChange={(e) => {
                                                    formik.setFieldValue("type", e.target.value);
                                                    formik.setFieldValue("month", "");
                                                    formik.setFieldValue("year", "");
                                                    formik.setFieldValue("category", "");
                                                    setShowTable(false);
                                                }}
                                            >
                                                <option value="">--select--</option>
                                                <option value="dist">District</option>
                                                <option value="mandal">Mandal</option>
                                                <option value="const">Constituency</option>
                                            </select>
                                        </div>
                                        <div className="col-12 col-md-2 d-flex flex-column gap-1">
                                            <label className="mb-0">
                                                {" "}
                                                Score-Cat <span className="text-danger">*</span>{" "}
                                            </label>
                                            <select
                                                className="form-select"
                                                name="category"
                                                value={formik.values.category}
                                                onChange={(e) => {
                                                    formik.setFieldValue("category", e.target.value);
                                                    formik.setFieldValue("year", "");
                                                    formik.setFieldValue("month", "");
                                                    setShowTable(false);
                                                }}
                                            >
                                                <option value="">--select--</option>
                                                {categoryOptions.map((opt) => (
                                                    <option key={opt.value} value={opt.value}>
                                                        {" "}
                                                        {opt.label}{" "}
                                                    </option>
                                                ))}{" "}
                                            </select>{" "}
                                        </div>
                                        <div className="col-12 col-md-2 d-flex flex-column gap-1">
                                            <label className="mb-0">
                                                {" "}
                                                Year <span className="text-danger">*</span>{" "}
                                            </label>
                                            <select
                                                className="form-select"
                                                name="year"
                                                value={formik.values.year}
                                                onChange={(e) => {
                                                    formik.setFieldValue("year", e.target.value);
                                                    formik.setFieldValue("month", "");
                                                    setSelectedDistrictId(null);
                                                    setTable1DrillLevel("dist");
                                                }}
                                            >
                                                <option value="">--select--</option>
                                                <option value="2026-27">2026-27</option>
                                                <option value="2025-26">2025-26</option>{" "}
                                            </select>{" "}
                                        </div>
                                        <div
                                            className="col-12 col-md-2 d-flex flex-column gap-1"
                                            style={{
                                                visibility: formik.values.category === "month" ? "visible" : "hidden",
                                            }}
                                        >
                                            <label className="mb-0">
                                                {" "}
                                                Month <span className="text-danger">*</span>{" "}
                                            </label>
                                            <select
                                                className="form-select"
                                                name="month"
                                                value={formik.values.month}
                                                onChange={(e) => {
                                                    const month = e.target.value;
                                                    formik.setFieldValue("month", month);
                                                    setSelectedDistrictId(null);
                                                    setTable1DrillLevel("dist");
                                                    const type = formik.values.type;
                                                    const category = formik.values.category;
                                                    const year = formik.values.year;
                                                    if (!type || !category || !year || !month) {
                                                        showAlertMessage(
                                                            "Please select all required fields",
                                                            "warning"
                                                        );
                                                        setShowTable(false);
                                                        return;
                                                    }
                                                    formik.handleSubmit();
                                                }}
                                            >
                                                <option value="">--select--</option>
                                                {monthOptions.map((opt) => (
                                                    <option key={opt.value} value={opt.value}>
                                                        {" "}
                                                        {opt.label}{" "}
                                                    </option>
                                                ))}
                                            </select>{" "}
                                        </div>{" "}
                                    </>{" "}
                                </div>{" "}
                            </div>{" "}
                        </div>

                        {showTable && (
                            <>
                                <div
                                    style={{display: "flex", gap: "20px", marginTop: "35px", alignItems: "flex-start"}}
                                >
                                    <div
                                        style={{
                                            width: "52%",
                                            // border: "1px solid #ddd",
                                            display: "flex",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <div
                                            className="d-flex justify-content-between align-items-center"
                                            style={{
                                                padding: "8px",
                                                background: "#fff",
                                                // borderBottom: "1px solid #ddd",
                                                position: "sticky",
                                                top: 0,
                                                zIndex: 20,
                                            }}
                                        >
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder={`Search ${
                                                    formik.values.type === "dist"
                                                        ? "District"
                                                        : formik.values.type === "mandal"
                                                        ? "Mandal"
                                                        : "Constituency"
                                                }...`}
                                                value={searchSummary}
                                                onChange={(e) => setSearchSummary(e.target.value)}
                                                style={{
                                                    width: "200px",
                                                    height: "34px",
                                                }}
                                            />

                                            <div className="d-flex gap-2">
                                                {selectedZone && (
                                                    <button
                                                        onClick={() => setSelectedZone(null)}
                                                        style={{
                                                            marginBottom: "8px",
                                                            padding: "5px 12px",
                                                            border: "none",
                                                            borderRadius: "5px",
                                                            backgroundColor: "#4e835c",
                                                            color: "#fff",
                                                            cursor: "pointer",
                                                            fontSize: "12px",
                                                        }}
                                                    >
                                                        Show All Zones
                                                    </button>
                                                )}
                                                <button
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() =>
                                                        generatePdff(
                                                            "#summary-table",
                                                            `${
                                                                formik.values.type === "dist"
                                                                    ? "District_Grade_Report"
                                                                    : formik.values.type === "mandal"
                                                                    ? "Mandal_Grade_Report"
                                                                    : "Constituency_Grade_Report"
                                                            }_${fileSuffix}`,
                                                            5,
                                                            ""
                                                        )
                                                    }
                                                >
                                                    <MdOutlinePictureAsPdf />
                                                </button>

                                                <button
                                                    className="btn btn-success btn-sm"
                                                    onClick={() =>
                                                        exportToExcel(
                                                            "summary-table",
                                                            `${
                                                                formik.values.type === "dist"
                                                                    ? "District_Grade_Report"
                                                                    : formik.values.type === "mandal"
                                                                    ? "Mandal_Grade_Report"
                                                                    : "Constituency_Grade_Report"
                                                            }_${fileSuffix}`
                                                        )
                                                    }
                                                >
                                                    <AiFillFileExcel />
                                                </button>
                                            </div>
                                        </div>

                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "repeat(4, 1fr)",
                                                alignItems: "center",
                                                padding: "5px 6px",
                                                columnGap: "3px",
                                                backgroundColor: "#fff",
                                                // borderBottom: "1px solid #ddd",
                                            }}
                                        >
                                            {[
                                                {
                                                    color: "#ff5a5a",
                                                    text: "Aspirant (C) <50%",
                                                },
                                                {
                                                    color: "#2fb4ff",
                                                    text: "Performer (B) 50%-74%",
                                                },
                                                {
                                                    color: "#f7c600",
                                                    text: "Front Runner (A) 75%-89%",
                                                },
                                                {
                                                    color: "#6cc04a",
                                                    text: "Achiever (A+) 90%-100%",
                                                },
                                            ].map((item) => (
                                                <div
                                                    key={item.text}
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        gap: "4px",
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            width: "18px",
                                                            height: "18px",
                                                            minWidth: "18px",
                                                            borderRadius: "50%",
                                                            backgroundColor: item.color,
                                                            display: "inline-block",
                                                        }}
                                                    />

                                                    <span
                                                        style={{
                                                            fontSize: "11px",
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        {item.text}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>

                                        {/* TABLE 1 */}
                                        <div style={{maxHeight: "680px", overflowY: "auto"}}>
                                            {/* <div style={{ maxHeight: filteredSummary.length > 8 ? "550px" : "none", overflowY: filteredSummary.length > 8 ? "auto" : "visible", overflowX: "auto" }} > */}
                                            <Table id="summary-table" bordered className="custom-table sticky-table" style={{
                                                                width: "100%",
                                                                borderCollapse: "separate",
                                                                borderSpacing: 0,
                                                                border: "1px solid #ffffff",
                                                            }}>
                                                <thead
                                                    style={{
                                                        position: "sticky",
                                                        top: 0,
                                                        zIndex: 10,
                                                        backgroundColor: "#4e835c",
                                                        // backgroundColor: "#fff",
                                                    }}
                                                >
                                                    <tr>
                                                        {" "}   <th colSpan={formik.values.type === "dist" ? "11" : "12"}>
                                                            {formik.values.category === "month"
                                                                ? `Economic, Social & Governance Performance – Month wise Report (${selectedMonth} ${formik.values.year})`
                                                                : formik.values.category === "provisional"
                                                                ? `Economic, Social & Governance Performance – Provisional Report (${formik.values.year})`
                                                                : `Economic, Social & Governance Performance – Annual Report (${formik.values.year})`}
                                                        </th>{" "}
                                                    </tr>
                                                    <tr>
                                                        <th rowSpan={2}>S.No</th>
                                                        <th rowSpan={2}>Zone</th>

                                                        {formik.values.type === "dist" ? (
                                                            <th rowSpan={2}>District</th>
                                                        ) : formik.values.type === "mandal" ? (
                                                            <>
                                                                <th rowSpan={2}> District</th>
                                                                <th rowSpan={2} style={{width: "50px"}}>
                                                                    Mandal
                                                                </th>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <th rowSpan={2}>District</th>
                                                                <th rowSpan={2}>Constituency</th>
                                                            </>
                                                        )}

                                                        {/* Economy */}
                                                        <th
                                                            colSpan={2}
                                                            onClick={() => handleSort("Economic")}
                                                            style={{cursor: "pointer"}}
                                                        >
                                                            Economy{" "}
                                                            {sortColumn === "Economic"
                                                                ? sortDirection === "asc"
                                                                    ? "▲"
                                                                    : "▼"
                                                                : "↕"}
                                                        </th>

                                                        {/* Social */}
                                                        <th
                                                            colSpan={2}
                                                            onClick={() => handleSort("Social")}
                                                            style={{cursor: "pointer"}}
                                                        >
                                                            Social{" "}
                                                            {sortColumn === "Social"
                                                                ? sortDirection === "asc"
                                                                    ? "▲"
                                                                    : "▼"
                                                                : "↕"}
                                                        </th>

                                                        {/* Governance */}
                                                        <th
                                                            colSpan={2}
                                                            onClick={() => handleSort("Governance")}
                                                            style={{cursor: "pointer"}}
                                                        >
                                                            Governance{" "}
                                                            {sortColumn === "Governance"
                                                                ? sortDirection === "asc"
                                                                    ? "▲"
                                                                    : "▼"
                                                                : "↕"}
                                                        </th>

                                                        <th
                                                            rowSpan={2}
                                                            onClick={() => handleSort("Score")}
                                                            style={{cursor: "pointer"}}
                                                        >
                                                            Score{" "}
                                                            {sortColumn === "Score"
                                                                ? sortDirection === "asc"
                                                                    ? "▲"
                                                                    : "▼"
                                                                : "↕"}
                                                        </th>

                                                        <th
                                                            rowSpan={2}
                                                            onClick={() => handleSort("Grade")}
                                                            style={{cursor: "pointer"}}
                                                        >
                                                            Grade{" "}
                                                            {sortColumn === "Grade"
                                                                ? sortDirection === "asc"
                                                                    ? "▲"
                                                                    : "▼"
                                                                : "↕"}
                                                        </th>
                                                    </tr>

                                                    {/* Sub headers */}
                                                    <tr>
                                                        <th>Score</th> <th>Grade</th>
                                                        <th>Score</th> <th>Grade</th>
                                                        <th>Score</th> <th>Grade</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {sortedSummary.length > 0 ? (
                                                        sortedSummary.map((row, i) => (
                                                            <tr key={i}>
                                                                <td style={{textAlign: "right"}}> {i + 1} </td>
                                                                <td style={{textAlign: "left"}}> {row.zone} </td>
                                                                {formik.values.type === "dist" ? (
                                                                    // <td style={{ textAlign: "left" }}> {row.name} </td>
                                                                    <td
                                                                        onClick={() => {
                                                                            setSelectedDistrictId(row.district_id);
                                                                            setTable1DrillLevel("mandal");
                                                                            handleDistrictClick(row);
                                                                        }}
                                                                        style={{
                                                                            cursor: "pointer",
                                                                            color: "#007bff",
                                                                            fontWeight: 600,
                                                                        
                                                                        }}
                                                                    >
                                                                        {row.name}
                                                                    </td>
                                                                ) : formik.values.type === "mandal" ? (
                                                                    <>
                                                                        <td
                                                                            style={{textAlign: "left", fontWeight: 600}}
                                                                        >
                                                                            {" "}
                                                                            {i === 0 ||
                                                                            sortedSummary[i - 1].districtId !==
                                                                                row.districtId
                                                                                ? row.district
                                                                                : ""}{" "}
                                                                        </td>
                                                                        <td style={{textAlign: "left", width: "50px"}}>
                                                                            {" "}
                                                                            {row.name}{" "}
                                                                        </td>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        {" "}
                                                                        <td style={{textAlign: "left"}}>
                                                                            {" "}
                                                                            {row.district}{" "}
                                                                        </td>
                                                                        <td style={{textAlign: "left"}}>
                                                                            {" "}
                                                                            {row.name}{" "}
                                                                        </td>
                                                                    </>
                                                                )}
                                                                {/* {["Economic", "Social", "Governance"].map((section) => (
                                                            <td
                                                                key={section}
                                                                style={{
                                                                    background: row[section]?.bg || "#fff",
                                                                    color: row[section]?.color || "#777",
                                                                    fontWeight: 600, textAlign: "center", borderRadius: "6px",
                                                                }}
                                                            > 
                                                            {row[section]?.text ? (
                                                                <> <div>{row[section].text}</div>
                                                                  <div style={{ fontSize: "12px", fontWeight: 700, marginTop: "2px", }} >
                                                                    Score: {row[section].score ?? "-"}
                                                                 </div> </> ) : ( "-" )} </td> ))} */}
                                                                {["Economic", "Social", "Governance"].map((section) => (
                                                                    <React.Fragment key={section}>
                                                                        {/* Score */}
                                                                        <td
                                                                            style={{
                                                                                background: row[section]?.bg || "#fff",
                                                                                color: row[section]?.color || "#777",
                                                                                fontWeight: 600,
                                                                                textAlign: "center",
                                                                            }}
                                                                        >
                                                                            {row[section]?.score ?? "-"}
                                                                        </td>

                                                                        {/* Grade */}
                                                                        <td
                                                                            style={{
                                                                                background: row[section]?.bg || "#fff",
                                                                                color: row[section]?.color || "#777",
                                                                                fontWeight: 600,
                                                                                textAlign: "center",
                                                                            }}
                                                                        >
                                                                            {row[section]?.text || "-"}
                                                                        </td>
                                                                    </React.Fragment>
                                                                ))}
                                                                <td style={{textAlign: "center", fontWeight: 600}}>
                                                                    {row.averageScore !== null ? row.averageScore : "-"}{" "}
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        textAlign: "center",
                                                                        fontWeight: 600,
                                                                        background:
                                                                            row.averageGrade === "A+"
                                                                                ? "#edf7ed"
                                                                                : row.averageGrade === "A"
                                                                                ? "#fff8e6"
                                                                                : row.averageGrade === "B"
                                                                                ? "#eef7fd"
                                                                                : row.averageGrade === "C"
                                                                                ? "#fdeeee"
                                                                                : "#fff",
                                                                        color:
                                                                            row.averageGrade === "A+"
                                                                                ? "#2e7d32"
                                                                                : row.averageGrade === "A"
                                                                                ? "#b26a00"
                                                                                : row.averageGrade === "B"
                                                                                ? "#1565c0"
                                                                                : row.averageGrade === "C"
                                                                                ? "#c62828"
                                                                                : "#777",
                                                                        borderRadius: "6px",
                                                                    }}
                                                                >
                                                                    {row.averageGrade}{" "}
                                                                </td>{" "}
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td
                                                                colSpan={formik.values.type === "dist" ? 7 : 8}
                                                                style={{
                                                                    textAlign: "center",
                                                                    fontWeight: 600,
                                                                    color: "#777",
                                                                    padding: "15px",
                                                                }}
                                                            >
                                                                {" "}
                                                                Data Not Available{" "}
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </Table>
                                        </div>
                                        {/* Table 4 */}
                                        {showTable4 && formik.values.type === "dist" && (
                                            // <div style={{ marginTop: "25px", width: "100%" }} >
                                            <div
                                                style={{
                                                    marginTop: "25px",
                                                    width: "100%",
                                                    maxHeight: "700px",
                                                    overflowY: "auto",
                                                    overflowX: "auto",
                                                    border: "1px solid #ddd",
                                                }}
                                            >
                                                <div
                                                    className="d-flex justify-content-between align-items-center"
                                                    style={{
                                                        marginBottom: "7px",
                                                        marginTop: "7px",
                                                        padding: "0 5px",
                                                    }}
                                                >
                                                    {/* LEFT - Search */}
                                                    <div style={{width: "250px"}}>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder="Search ..."
                                                            value={table4Search}
                                                            onChange={(e) => setTable4Search(e.target.value)}
                                                            style={{
                                                                height: "34px",
                                                                borderRadius: "5px",
                                                                border: "1px solid #ccc",
                                                            }}
                                                        />
                                                    </div>

                                                    {/* RIGHT - Buttons */}
                                                    <div className="d-flex gap-2">
                                                        <button
                                                            className="btn btn-success btn-sm"
                                                            onClick={() =>
                                                                exportToExcel(
                                                                    "table4",
                                                                    `${table4Summary?.[0]?.district_name
                                                                    ?.toLowerCase()
                                                                    .replace(/\b\w/g, (char) =>
                                                                        char.toUpperCase()
                                                                    )}_Mandals_Performance_Monitoring_Report${fileSuffix}`
                                                                )
                                                            }
                                                        >
                                                            <AiFillFileExcel />
                                                        </button>

                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary btn-sm"
                                                            onClick={() => {
                                                                setShowTable4(false);
                                                                setSelectedDistrictId(null);
                                                                setTable4Data([]);
                                                                setTable4Search("");
                                                            }}
                                                        >
                                                            Close
                                                        </button>
                                                    </div>
                                                </div>

                                                <Table
                                                    bordered
                                                    id="table4"
                                                    className="custom-table table table-bordered"
                                                >
                                                    <thead
                                                        style={{
                                                            position: "sticky",
                                                            top: 0,
                                                            zIndex: 20,
                                                            backgroundColor: "#4e835c",
                                                        }}
                                                    >
                                                        <tr>
                                                            <th colspan={12}>
                                                                {" "}
                                                                Mandal Performance Monitoring Report of {" "}
                                                                {table4Summary?.[0]?.district_name
                                                                ?.toLowerCase()
                                                                .replace(/\b\w/g, (char) => char.toUpperCase())}{" "}
                                                                ({selectedMonth} {formik.values.year})
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <th rowSpan="2">S.No</th>
                                                            <th rowSpan="2">Zone</th>
                                                            <th rowSpan="2">District</th>
                                                            <th rowSpan="2">Mandal</th>

                                                            <th
                                                                colSpan="2"
                                                                onClick={() => handleTable4Sort("Economic")}
                                                                style={{cursor: "pointer"}}
                                                            >
                                                                Economic{" "}
                                                                {table4SortColumn === "Economic"
                                                                    ? table4SortDirection === "asc"
                                                                        ? "▲"
                                                                        : "▼"
                                                                    : "↕"}
                                                            </th>

                                                            <th
                                                                colSpan="2"
                                                                onClick={() => handleTable4Sort("Social")}
                                                                style={{cursor: "pointer"}}
                                                            >
                                                                Social{" "}
                                                                {table4SortColumn === "Social"
                                                                    ? table4SortDirection === "asc"
                                                                        ? "▲"
                                                                        : "▼"
                                                                    : "↕"}
                                                            </th>

                                                            <th
                                                                colSpan="2"
                                                                onClick={() => handleTable4Sort("Governance")}
                                                                style={{cursor: "pointer"}}
                                                            >
                                                                Governance{" "}
                                                                {table4SortColumn === "Governance"
                                                                    ? table4SortDirection === "asc"
                                                                        ? "▲"
                                                                        : "▼"
                                                                    : "↕"}
                                                            </th>

                                                            <th
                                                                rowSpan="2"
                                                                onClick={() => handleTable4Sort("Score")}
                                                                style={{cursor: "pointer"}}
                                                            >
                                                                Score{" "}
                                                                {table4SortColumn === "Score"
                                                                    ? table4SortDirection === "asc"
                                                                        ? "▲"
                                                                        : "▼"
                                                                    : "↕"}
                                                            </th>

                                                            <th
                                                                rowSpan="2"
                                                                onClick={() => handleTable4Sort("Grade")}
                                                                style={{cursor: "pointer"}}
                                                            >
                                                                Grade{" "}
                                                                {table4SortColumn === "Grade"
                                                                    ? table4SortDirection === "asc"
                                                                        ? "▲"
                                                                        : "▼"
                                                                    : "↕"}
                                                            </th>
                                                        </tr>

                                                        <tr>
                                                            <th>Score</th>
                                                            <th>Grade</th>

                                                            <th>Score</th>
                                                            <th>Grade</th>

                                                            <th>Score</th>
                                                            <th>Grade</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {sortedTable4Summary.length > 0 ? (
                                                            sortedTable4Summary.map((item, index) => {
                                                                const economy = item.Economic
                                                                    ? getGradeDetails(item.Economic.grade)
                                                                    : getGradeDetails("-");

                                                                const social = item.Social
                                                                    ? getGradeDetails(item.Social.grade)
                                                                    : getGradeDetails("-");

                                                                const governance = item.Governance
                                                                    ? getGradeDetails(item.Governance.grade)
                                                                    : getGradeDetails("-");

                                                                const overall = getGradeDetails(item.overallGrade);

                                                                return (
                                                                    <tr
                                                                        key={
                                                                            item.mandal_id ||
                                                                            `${item.district_id}-${index}`
                                                                        }
                                                                    >
                                                                        {/* S.No */}
                                                                        <td>{index + 1}</td>
                                                                        <td>{item.zone}</td>

                                                                        {/* District */}
                                                                        <td> {item.district_name || "-"} </td>

                                                                        {/* Mandal */}
                                                                        <td>{item.mandal_name || "-"}</td>

                                                                        {/* ================= ECONOMIC SCORE ================= */}
                                                                        <td
                                                                            style={{
                                                                                background: economy?.bg || "#fff",
                                                                                color: economy?.color || "#777",
                                                                                textAlign: "center",
                                                                                fontWeight: 600,
                                                                            }}
                                                                        >
                                                                            {item.Economic?.score ?? "-"}
                                                                        </td>

                                                                        {/* ================= ECONOMIC GRADE ================= */}
                                                                        <td
                                                                            style={{
                                                                                background: economy?.bg || "#fff",
                                                                                color: economy?.color || "#777",
                                                                                textAlign: "center",
                                                                                fontWeight: 600,
                                                                            }}
                                                                        >
                                                                            {economy?.text || "-"}
                                                                        </td>

                                                                        {/* ================= SOCIAL SCORE ================= */}
                                                                        <td
                                                                            style={{
                                                                                background: social?.bg || "#fff",
                                                                                color: social?.color || "#777",
                                                                                textAlign: "center",
                                                                                fontWeight: 600,
                                                                            }}
                                                                        >
                                                                            {item.Social?.score ?? "-"}
                                                                        </td>

                                                                        {/* ================= SOCIAL GRADE ================= */}
                                                                        <td
                                                                            style={{
                                                                                background: social?.bg || "#fff",
                                                                                color: social?.color || "#777",
                                                                                textAlign: "center",
                                                                                fontWeight: 600,
                                                                            }}
                                                                        >
                                                                            {social?.text || "-"}
                                                                        </td>

                                                                        {/* ================= GOVERNANCE SCORE ================= */}
                                                                        <td
                                                                            style={{
                                                                                background: governance?.bg || "#fff",
                                                                                color: governance?.color || "#777",
                                                                                textAlign: "center",
                                                                                fontWeight: 600,
                                                                            }}
                                                                        >
                                                                            {item.Governance?.score ?? "-"}
                                                                        </td>

                                                                        {/* ================= GOVERNANCE GRADE ================= */}
                                                                        <td
                                                                            style={{
                                                                                background: governance?.bg || "#fff",
                                                                                color: governance?.color || "#777",
                                                                                textAlign: "center",
                                                                                fontWeight: 600,
                                                                            }}
                                                                        >
                                                                            {governance?.text || "-"}
                                                                        </td>

                                                                        {/* ================= OVERALL SCORE ================= */}
                                                                        <td
                                                                            style={{
                                                                                textAlign: "center",
                                                                                fontWeight: 600,
                                                                            }}
                                                                        >
                                                                            {item.overallScore ?? "-"}
                                                                        </td>

                                                                        {/* ================= OVERALL GRADE ================= */}
                                                                        <td
                                                                            style={{
                                                                                background: overall?.bg || "#fff",
                                                                                color: overall?.color || "#777",
                                                                                textAlign: "center",
                                                                                fontWeight: 600,
                                                                            }}
                                                                        >
                                                                            {overall?.text || "-"}
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })
                                                        ) : (
                                                            <tr>
                                                                <td
                                                                    colSpan="12"
                                                                    style={{
                                                                        textAlign: "center",
                                                                        padding: "20px",
                                                                    }}
                                                                >
                                                                    No data available
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </Table>
                                            </div>
                                        )}
                                    </div>

                                    {/* <div style={{ width: "48%", maxHeight: "450px", overflow: "auto" }} > */}
                                    <div style={{width: "48%", display: "flex", flexDirection: "column", gap: "20px"}}>
                                        <div style={{width: "100%", overflowX: "auto"}}>
                                            {showTable && (
                                                <div className="col d-flex justify-content-end align-items-end pe-3">
                                                    <div className="d-flex gap-2" style={{marginBottom: "7px"}}>
                                                        <button
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() =>
                                                                generatePerformancePdf(
                                                                    "#my-table",
                                                                    `${reportName}_${fileSuffix}`,
                                                                    ""
                                                                )
                                                            }
                                                        >
                                                            PDF <MdOutlinePictureAsPdf />
                                                        </button>
                                                        <button
                                                            className="btn btn-success btn-sm"
                                                            onClick={() =>
                                                                exportToExcel("my-table", `${reportName}_${fileSuffix}`)
                                                            }
                                                        >
                                                            Excel <AiFillFileExcel />
                                                        </button>{" "}
                                                    </div>{" "}
                                                </div>
                                            )}
                                            {/* Table 2 */}
                                            <Table
                                                style={{width: "100%", marginBottom: 0}}
                                                bordered
                                                id="my-table"
                                                className="custom-table table-responsive table table-bordered sticky-table"
                                            >
                                                <thead>
                                                    <tr>
                                                        {" "}
                                                        <th colSpan={6}>{reportTitle}</th>{" "}
                                                    </tr>
                                                    <tr>
                                                        {" "}
                                                        <th>Section</th>{" "}
                                                        <th style={{backgroundColor: "#6cc04a"}}>
                                                            Achiever (A+) <br /> (&gt;90%){" "}
                                                        </th>{" "}
                                                        <th style={{backgroundColor: "#f7c600"}}>
                                                            Front Runner (A) <br /> (75%-89%)
                                                        </th>
                                                        <th style={{backgroundColor: "#4ecdc4"}}>
                                                            Performer (B) <br /> (50%-74%)
                                                        </th>{" "}
                                                        <th style={{backgroundColor: "#ff5a5a"}}>
                                                            Aspirant (C) <br /> (&lt;50%){" "}
                                                        </th>
                                                        <th>
                                                            {" "}
                                                            {formik.values.type === "dist"
                                                                ? "Total Districts"
                                                                : formik.values.type === "mandal"
                                                                ? "Total Mandals"
                                                                : "Total Constituencies"}{" "}
                                                        </th>{" "}
                                                    </tr>{" "}
                                                </thead>

                                                <tbody>
                                                    {groupedReport.map((row) => (
                                                        <tr key={row.section}>
                                                            {" "}
                                                            <td>{row.section}</td>
                                                            <td
                                                                style={{
                                                                    textAlign: "right",
                                                                    cursor: "pointer",
                                                                    color: "blue",
                                                                }}
                                                                onClick={() => handleGradeClickMandal(row, "A+")}
                                                            >
                                                                {" "}
                                                                {row["A+"]}{" "}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    textAlign: "right",
                                                                    cursor: "pointer",
                                                                    color: "blue",
                                                                }}
                                                                onClick={() => handleGradeClickMandal(row, "A")}
                                                            >
                                                                {" "}
                                                                {row["A"]}{" "}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    textAlign: "right",
                                                                    cursor: "pointer",
                                                                    color: "blue",
                                                                }}
                                                                onClick={() => handleGradeClickMandal(row, "B")}
                                                            >
                                                                {" "}
                                                                {row["B"]}{" "}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    textAlign: "right",
                                                                    cursor: "pointer",
                                                                    color: "blue",
                                                                }}
                                                                onClick={() => handleGradeClickMandal(row, "C")}
                                                            >
                                                                {" "}
                                                                {row["C"]}{" "}
                                                            </td>
                                                            <td style={{textAlign: "right"}}> {row.total} </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>{" "}
                                        </div>

                                        {/* Table 3 */}
                                        {formik.values.type === "dist" && (
                                            <div style={{width: "100%", overflowX: "auto"}}>
                                                <div
                                                    className="d-flex justify-content-end align-items-center"
                                                    style={{marginBottom: "7px"}}
                                                >
                                                    <div className="d-flex gap-2">
                                                        {/* <button className="btn btn-danger btn-sm" onClick={() => generatePerformancePdf( "#table3", `Table3_${fileSuffix}`, "" ) } > PDF <MdOutlinePictureAsPdf /> </button> */}

                                                        <button
                                                            className="btn btn-success btn-sm"
                                                            onClick={() =>
                                                                exportToExcel(
                                                                    "table3",
                                                                    `Zone-wise Performance Monitoring Report_${fileSuffix}`
                                                                )
                                                            }
                                                        >
                                                            Excel <AiFillFileExcel />
                                                        </button>
                                                    </div>
                                                </div>

                                                <Table
                                                    bordered
                                                    id="table3"
                                                    className="custom-table table-responsive table table-bordered"
                                                >
                                                    <thead
                                                        style={{
                                                            position: "sticky",
                                                            top: 0,
                                                            zIndex: 20,
                                                            backgroundColor: "#4e835c",
                                                        }}
                                                    >
                                                        <tr>
                                                            {" "}
                                                            <th colSpan={formik.values.type === "dist" ? "11" : "12"}>
                                                                {formik.values.category === "month"
                                                                    ? `Zone-wise Monthly Performance Monitoring Report (${selectedMonth} ${formik.values.year})`
                                                                    : formik.values.category === "provisional"
                                                                    ? `Zone-wise Provisionally Performance Monitoring Report (${formik.values.year})`
                                                                    : `Zone-wise Annually Performance Monitoring Report (${formik.values.year})`}
                                                            </th>{" "}
                                                        </tr>
                                                        <tr>
                                                            {" "}
                                                            <th rowSpan={2}>S.No</th> <th rowSpan={2}>Zone</th>
                                                            <th colSpan={2}>Economy</th> <th colSpan={2}>Social</th>{" "}
                                                            <th colSpan={2}>Governance</th>
                                                            <th rowSpan={2}>Score</th> <th rowSpan={2}>Grade</th>
                                                        </tr>

                                                        <tr>
                                                            {" "}
                                                            <th>Score</th> <th>Grade</th>
                                                            <th>Score</th> <th>Grade</th>
                                                            <th>Score</th> <th>Grade</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {zoneSummary.map((item, index) => {
                                                            const getGrade = (score) => {
                                                                if (
                                                                    score === null ||
                                                                    score === undefined ||
                                                                    isNaN(Number(score))
                                                                ) {
                                                                    return "-";
                                                                }

                                                                const value = Number(score);

                                                                if (value >= 90) return "A+";
                                                                if (value >= 75) return "A";
                                                                if (value >= 50) return "B";
                                                                return "C";
                                                            };

                                                            const economyGrade = getGrade(item.economic_score);
                                                            const socialGrade = getGrade(item.social_score);
                                                            const governanceGrade = getGrade(item.governance_score);

                                                            const economy = getGradeDetails(economyGrade);
                                                            const social = getGradeDetails(socialGrade);
                                                            const governance = getGradeDetails(governanceGrade);

                                                            return (
                                                                <tr key={item.zone_id || index}>
                                                                    <td>{index + 1}</td>

                                                                    {/* <td>{item.zone_name}</td> */}
                                                                    <td
                                                                        onClick={() => {
                                                                            setSelectedZone(item.zone_id);
                                                                            setSearchSummary("");
                                                                        }}
                                                                        style={{
                                                                            cursor: "pointer",
                                                                            color: "#007bff",
                                                                            fontWeight: "700",
                                                                        }}
                                                                    >
                                                                        {" "}
                                                                        {item.zone_name}{" "}
                                                                    </td>

                                                                    {/* Economy Score */}
                                                                    <td
                                                                        style={{
                                                                            background: economy?.bg || "#fff",
                                                                            color: economy?.color || "#777",
                                                                            textAlign: "center",
                                                                            fontWeight: 600,
                                                                        }}
                                                                    >
                                                                        {item.economic_score ?? "-"}
                                                                    </td>

                                                                    {/* Economy Grade */}
                                                                    <td
                                                                        style={{
                                                                            background: economy?.bg || "#fff",
                                                                            color: economy?.color || "#777",
                                                                            fontWeight: 600,
                                                                            textAlign: "center",
                                                                        }}
                                                                    >
                                                                        {economy?.text || "-"}
                                                                    </td>

                                                                    {/* Social Score */}
                                                                    <td
                                                                        style={{
                                                                            background: social?.bg || "#fff",
                                                                            color: social?.color || "#777",
                                                                            textAlign: "center",
                                                                            fontWeight: 600,
                                                                        }}
                                                                    >
                                                                        {item.social_score ?? "-"}
                                                                    </td>

                                                                    {/* Social Grade */}
                                                                    <td
                                                                        style={{
                                                                            background: social?.bg || "#fff",
                                                                            color: social?.color || "#777",
                                                                            fontWeight: 600,
                                                                            textAlign: "center",
                                                                        }}
                                                                    >
                                                                        {social?.text || "-"}
                                                                    </td>

                                                                    {/* Governance Score */}
                                                                    <td
                                                                        style={{
                                                                            background: governance?.bg || "#fff",
                                                                            color: governance?.color || "#777",
                                                                            textAlign: "center",
                                                                            fontWeight: 600,
                                                                        }}
                                                                    >
                                                                        {item.governance_score ?? "-"}
                                                                    </td>

                                                                    {/* Governance Grade */}
                                                                    <td
                                                                        style={{
                                                                            background: governance?.bg || "#fff",
                                                                            color: governance?.color || "#777",
                                                                            fontWeight: 600,
                                                                            textAlign: "center",
                                                                        }}
                                                                    >
                                                                        {governance?.text || "-"}
                                                                    </td>

                                                                    {/* Overall Score */}
                                                                    <td
                                                                        style={{
                                                                            textAlign: "center",
                                                                            fontWeight: 600,
                                                                        }}
                                                                    >
                                                                        {item.zone_score ?? "-"}
                                                                    </td>

                                                                    {/* Overall Grade */}
                                                                    <td
                                                                        style={{
                                                                            textAlign: "center",
                                                                            fontWeight: 600,
                                                                            background:
                                                                            item.grade === "A+"
                                                                                ? "#edf7ed"
                                                                                : item.grade === "A"
                                                                                ? "#fff8e6"
                                                                                : item.grade === "B"
                                                                                ? "#eef7fd"
                                                                                : item.grade === "C"
                                                                                ? "#fdeeee"
                                                                                : "#fff",
                                                                        color:
                                                                            item.grade === "A+"
                                                                                ? "#2e7d32"
                                                                                : item.grade === "A"
                                                                                ? "#b26a00"
                                                                                : item.grade === "B"
                                                                                ? "#1565c0"
                                                                                : item.grade === "C"
                                                                                ? "#c62828"
                                                                                : "#777",
                                                                        }}
                                                                    >
                                                                        {item.grade ?? "-"}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </Table>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <Modal
                                    show={showPopup}
                                    onHide={handleClosePopup}
                                    dialogClassName={
                                        indicatorSelected
                                            ? "side-by-side-modal expanded-modal"
                                            : "side-by-side-modal collapsed-modal"
                                    }
                                    centered
                                >
                                    <Modal.Header closeButton>
                                        {" "}
                                        <Modal.Title style={{width: "100%", textAlign: "center"}}>
                                            {" "}
                                            {popupTitle}{" "}
                                        </Modal.Title>{" "}
                                    </Modal.Header>
                                    <Modal.Body className="p-2">
                                        <div
                                            style={{
                                                display: "flex",
                                                width: "100%",
                                                gap: "12px",
                                                justifyContent: indicatorSelected ? "space-between" : "center",
                                                transition: "all 0.4s ease",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: indicatorSelected ? "42%" : "100%",
                                                    margin: indicatorSelected ? "0" : "0 auto",
                                                    transition: "all 0.4s ease",
                                                    minWidth: 0,
                                                }}
                                            >
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search..."
                                                        value={searchPopup}
                                                        onChange={(e) => setSearchPopup(e.target.value)}
                                                        style={{
                                                            width: "160px",
                                                            height: "34px",
                                                            borderRadius: "5px",
                                                            flexShrink: 0,
                                                        }}
                                                    />

                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "4px",
                                                            marginRight: "25px",
                                                            flexShrink: 0,
                                                        }}
                                                    >
                                                        <button
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() =>
                                                                generatePdff(
                                                                    "#popup-table",
                                                                    `${reportName}_${fileSuffix}`,
                                                                    formik.values.type === "dist" ? 2 : 3,
                                                                    popupTitle
                                                                )
                                                            }
                                                        >
                                                            <MdOutlinePictureAsPdf />{" "}
                                                        </button>
                                                        <button
                                                            className="btn btn-success btn-sm"
                                                            onClick={() =>
                                                                exportToExcel(
                                                                    "popup-table",
                                                                    `${reportName}_${fileSuffix}`
                                                                )
                                                            }
                                                        >
                                                            <AiFillFileExcel />{" "}
                                                        </button>{" "}
                                                    </div>
                                                </div>

                                                <div className="popup-height">
                                                    <Table
                                                        bordered
                                                        id="popup-table"
                                                        className="custom-table table-bordered "
                                                    >
                                                        <thead
                                                            style={{
                                                                position: "sticky",
                                                                top: 0,
                                                                zIndex: 100,
                                                                background: "#4e835c",
                                                            }}
                                                        >
                                                            <tr>
                                                                {" "}
                                                                <th style={{display: "none"}}> {popupTitle} </th>{" "}
                                                            </tr>

                                                            {formik.values.type === "dist" ? (
                                                                <>
                                                                    <tr>
                                                                        {" "}
                                                                        <th colSpan={3}>
                                                                            {" "}
                                                                            District Performance Monitoring Report{" "}
                                                                        </th>{" "}
                                                                    </tr>

                                                                    <tr>
                                                                        <th style={{width: "60px"}}>S.No</th>{" "}
                                                                        <th>District</th>
                                                                        <th style={{width: "110px"}}>
                                                                            {" "}
                                                                            Total Indicators{" "}
                                                                        </th>
                                                                    </tr>
                                                                </>
                                                            ) : formik.values.type === "mandal" ? (
                                                                <>
                                                                    <tr>
                                                                        {" "}
                                                                        <th colSpan={4}>
                                                                            {" "}
                                                                            District &amp; Mandal Performance Monitoring
                                                                            Report{" "}
                                                                        </th>{" "}
                                                                    </tr>

                                                                    <tr>
                                                                        {" "}
                                                                        <th style={{width: "60px"}}>S.No</th>{" "}
                                                                        <th>District</th>
                                                                        <th>Mandal</th>{" "}
                                                                        <th style={{width: "110px"}}>
                                                                            {" "}
                                                                            Total Indicators{" "}
                                                                        </th>
                                                                    </tr>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <tr>
                                                                        {" "}
                                                                        <th colSpan={4}>
                                                                            {" "}
                                                                            District &amp; Constituency Performance
                                                                            Monitoring Report{" "}
                                                                        </th>{" "}
                                                                    </tr>

                                                                    <tr>
                                                                        {" "}
                                                                        <th style={{width: "60px"}}>S.No</th>{" "}
                                                                        <th>District</th>
                                                                        <th>Constituency</th>{" "}
                                                                        <th style={{width: "110px"}}>
                                                                            {" "}
                                                                            Total Indicators{" "}
                                                                        </th>
                                                                    </tr>
                                                                </>
                                                            )}
                                                        </thead>
                                                        <tbody>
                                                            {formik.values.type === "dist" ? (
                                                                filteredPopupData.length > 0 ? (
                                                                    filteredPopupData.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td style={{textAlign: "right"}}>
                                                                                {index + 1}
                                                                            </td>

                                                                            <td>{item.district}</td>

                                                                            <td
                                                                                style={{
                                                                                    textAlign: "right",
                                                                                    color: "blue",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                                onClick={() =>
                                                                                    handleIndicatorClick(item)
                                                                                }
                                                                            >
                                                                                {item.total}
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan={3} className="text-center">
                                                                            No Data Available
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            ) : formik.values.type === "mandal" ? (
                                                                filteredPopupData.length > 0 ? (
                                                                    filteredPopupData.map((item, index) => {
                                                                        const showDistrict =
                                                                            index === 0 ||
                                                                            filteredPopupData[index - 1]
                                                                                .district_name !== item.district_name;

                                                                        return (
                                                                            <tr key={index}>
                                                                                <td style={{textAlign: "center"}}>
                                                                                    {index + 1}
                                                                                </td>

                                                                                <td>
                                                                                    {showDistrict
                                                                                        ? item.district_name
                                                                                        : ""}
                                                                                </td>

                                                                                <td>{item.mandal_name}</td>

                                                                                <td
                                                                                    style={{
                                                                                        textAlign: "right",
                                                                                        color: "blue",
                                                                                        cursor: "pointer",
                                                                                    }}
                                                                                    onClick={() =>
                                                                                        handleIndicatorClick(item)
                                                                                    }
                                                                                >
                                                                                    {item.total}
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan={4} className="text-center">
                                                                            No Data Available
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            ) : filteredPopupData.length > 0 ? (
                                                                filteredPopupData.map((item, index) => {
                                                                    const showDistrict =
                                                                        index === 0 ||
                                                                        filteredPopupData[index - 1].district_name !==
                                                                            item.district_name;

                                                                    return (
                                                                        <tr key={index}>
                                                                            <td style={{textAlign: "center"}}>
                                                                                {index + 1}
                                                                            </td>

                                                                            <td>
                                                                                {showDistrict ? item.district_name : ""}
                                                                            </td>

                                                                            <td>{item.acname}</td>

                                                                            <td
                                                                                style={{
                                                                                    textAlign: "right",
                                                                                    color: "blue",
                                                                                    cursor: "pointer",
                                                                                }}
                                                                                onClick={() =>
                                                                                    handleIndicatorClick(item)
                                                                                }
                                                                            >
                                                                                {item.total}
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan={4} className="text-center">
                                                                        No Data Available
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </div>
                                            {indicatorSelected && (
                                                <div style={{width: "55%", minWidth: 0}}>
                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Search Indicator..."
                                                            value={searchIndicator}
                                                            onChange={(e) => setSearchIndicator(e.target.value)}
                                                            style={{
                                                                width: "220px",
                                                                height: "34px",
                                                            }}
                                                        />

                                                        <div className="d-flex gap-2">
                                                            <button
                                                                className="btn btn-danger btn-sm"
                                                                onClick={() =>
                                                                    generatePdff(
                                                                        "#indicator-table",
                                                                        `Indicator_Details_${fileSuffix}`,
                                                                        3,
                                                                        indicatorPopupTitle || popupTitle
                                                                    )
                                                                }
                                                            >
                                                                <MdOutlinePictureAsPdf />
                                                            </button>

                                                            <button
                                                                className="btn btn-success btn-sm"
                                                                onClick={() =>
                                                                    exportToExcel(
                                                                        "indicator-table",
                                                                        `Indicator_Details_${fileSuffix}`
                                                                    )
                                                                }
                                                            >
                                                                <AiFillFileExcel />
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <div className="popup-height">
                                                        <Table
                                                            bordered
                                                            id="indicator-table"
                                                            className="custom-table table-bordered"
                                                        >
                                                            <thead
                                                                style={{
                                                                    position: "sticky",
                                                                    top: 0,
                                                                    background: "#4e835c",
                                                                    zIndex: 100,
                                                                }}
                                                            >
                                                                <tr>
                                                                    {" "}
                                                                    <th colSpan={3}>
                                                                        {" "}
                                                                        {indicatorPopupTitle}{" "}
                                                                        {formik.values.type === "dist"
                                                                            ? " District"
                                                                            : formik.values.type === "mandal"
                                                                            ? " Mandal"
                                                                            : "Constituency"}{" "}
                                                                        Performance Monitoring Report{" "}
                                                                    </th>{" "}
                                                                </tr>
                                                                <tr>
                                                                    {" "}
                                                                    <th style={{width: "60px"}}>S.No</th>{" "}
                                                                    <th style={{width: "180px"}}>Indicator Name</th>{" "}
                                                                    <th style={{width: "90px"}}>Score</th>{" "}
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                {filteredIndicatorData.length > 0 ? (
                                                                    filteredIndicatorData.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td
                                                                                style={{
                                                                                    textAlign: "right",
                                                                                    width: "60px",
                                                                                }}
                                                                            >
                                                                                {index + 1}
                                                                            </td>

                                                                            <td style={{width: "180px"}}>
                                                                                {item.indicator_name}
                                                                            </td>

                                                                            <td
                                                                                style={{
                                                                                    textAlign: "center",
                                                                                    verticalAlign: "middle",
                                                                                    display: "flex",
                                                                                    justifyContent: "center",
                                                                                    alignItems: "center",
                                                                                }}
                                                                            >
                                                                                {renderStatusRing(
                                                                                    item.indicator_score,
                                                                                    100,
                                                                                    40,
                                                                                    6
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td
                                                                            colSpan={3}
                                                                            className="text-center text-danger fw-bold"
                                                                        >
                                                                            No Data Available
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </Modal.Body>
                                </Modal>
                            </>
                        )}
                    </div>{" "}
                </div>

                <AlertModal
                    show={showAlert}
                    titleText={alertData.titleText}
                    alertText={alertData.alertText}
                    onClose={closeAlert}
                />
            </div>
        </>
    );
};

export default PerformanceMonitoringReport;
